import React, { useState } from "react";
import { postComptaStageForm, finalizeComptaStage } from "./comptaStageHelpers";
import { CommentField, ToggleGroup, ReadField, SubmitBar } from "./FormFields";
import { cardCls, labelCls, inputCls } from "./formStyles";

// Étape 5/5 — Bouclage mensuel. Dernière étape : pas de création de ToDo lié
// (rien à assigner ensuite) et — comme dans l'original — pas de sélecteur
// "Personne à notifier" dans ce formulaire (même si emailBouclagePayload
// envoie bien un userEmails, systématiquement vide ici puisqu'aucune UI ne
// permet de le remplir à cette étape).
function BouclageStage({
  tache,
  showFormInstead,
  selectedClient,
  selectedYear,
  selectedMonth,
  refetch,
  setShowOverlay,
  utilisateur,
}) {
  const [formData, setFormData] = useState({
    volumePiece: "",
    dateEnvoie: "",
    commentaireBouclage: "",
    tva: "",
    is: "",
    ts: "",
    cfe: "",
    userIds: [],
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const payloadbouclage = {
        volumePiece: formData.volumePiece,
        dateEnvoie: formData.dateEnvoie,
        commentaire: formData.commentaireBouclage,
        tva: formData.tva,
        is: formData.is,
        ts: formData.ts,
        cfe: formData.cfe,
      };

      const tacheId = await postComptaStageForm({
        clientId: selectedClient.id,
        year: selectedYear,
        month: selectedMonth,
        stage: "bouclage",
        payload: payloadbouclage,
      });

      const emailBouclagePayload = {
        NomComplet: `${utilisateur.lastName} ${utilisateur.name}`,
        nomDossier: selectedClient?.nom || "",
        volumePiece: formData.volumePiece,
        dateEnvoie: formData.dateEnvoie,
        commentaireBouclage: formData.commentaireBouclage,
        tva: formData.tva,
        is: formData.is,
        ts: formData.ts,
        cfe: formData.cfe,
        userEmails: formData.userIds,
      };
      const clientIdBouclage = selectedClient.id;

      setLoading(false);
      setShowOverlay(false);
      setSuccess(true);
      setFormData({
        volumePiece: "",
        dateEnvoie: "",
        commentaireBouclage: "",
        tva: "",
        is: "",
        ts: "",
        cfe: "",
        userIds: [],
      });

      finalizeComptaStage({
        clientId: clientIdBouclage,
        tacheId,
        emailEndpoint: "https://backend-myalfa.vercel.app/api/email-bouclage",
        emailPayload: emailBouclagePayload,
        prevTodoEndpoint: `https://backend-myalfa.vercel.app/api/compta/${clientIdBouclage}/${selectedYear}/${selectedMonth}/traitement2/todo`,
        refetch,
      });
    } catch (err) {
      setError(err.message);
      setLoading(false);
      setShowOverlay(false);
    }
  };

  return (
    <>
      {showFormInstead && (
        <form
          className={cardCls}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit(tache.id);
          }}
        >
          <p className="text-sm font-bold text-[#5C1A30]">5 / Bouclage mensuel</p>

          <div>
            <label className={labelCls}>Volume de pièces manquantes</label>
            <select
              value={formData.volumePiece}
              onChange={(e) => setFormData({ ...formData, volumePiece: e.target.value })}
              className={inputCls}
            >
              <option value="">Veuillez sélectionner</option>
              {["Faible", "Bonne", "Excellente"].map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className={labelCls}>Date d'envoie de la demande</label>
            <input
              type="datetime-local"
              value={formData.dateEnvoie}
              onChange={(e) => setFormData({ ...formData, dateEnvoie: e.target.value })}
              required
              className={inputCls}
            />
          </div>

          <CommentField
            value={formData.commentaireBouclage}
            onChange={(e) => setFormData({ ...formData, commentaireBouclage: e.target.value })}
          />

          <p className="text-sm font-bold text-[#5C1A30] text-center pt-2">
            Suivi des échéances fiscales
          </p>

          <ToggleGroup
            label="TVA"
            value={formData.tva}
            onChange={(v) => setFormData({ ...formData, tva: v })}
            options={["Fait", "Pas Fait", "N/A"]}
          />
          <ToggleGroup
            label="IS"
            value={formData.is}
            onChange={(v) => setFormData({ ...formData, is: v })}
            options={["Fait", "Pas Fait", "N/A"]}
          />
          <ToggleGroup
            label="TS"
            value={formData.ts}
            onChange={(v) => setFormData({ ...formData, ts: v })}
            options={["Fait", "Pas Fait", "N/A"]}
          />
          <ToggleGroup
            label="CFE"
            value={formData.cfe}
            onChange={(v) => setFormData({ ...formData, cfe: v })}
            options={["Fait", "Pas Fait", "N/A"]}
          />

          <SubmitBar loading={loading} error={error} success={success} />
        </form>
      )}

      {tache.bouclageForm && (
        <div className={cardCls}>
          <ReadField
            label="Volume de pièces manquantes"
            value={tache.bouclageForm.volumePiece}
          />
          <ReadField
            label="Date d'envoie de la demande"
            value={new Date(tache.bouclageForm.dateEnvoie).toLocaleString()}
          />
          <ReadField label="Commentaire" value={tache.bouclageForm.commentaire} />
          <ReadField label="TVA" value={tache.bouclageForm.tva} />
          <ReadField label="IS" value={tache.bouclageForm.is} />
          <ReadField label="TS" value={tache.bouclageForm.ts} />
          <ReadField label="CFE" value={tache.bouclageForm.cfe} />
        </div>
      )}
    </>
  );
}

export default BouclageStage;
